import {
  Stringified,
  ionicStorageClass,
} from "@/persistentStorage/ionicStorageClass";

import { userTokenStore, IToken } from "@/stores/tokenStore";

import { useHeaderData, IHeaderData } from "@/globals/stores/storeHeaderData";
import { useFooterData, IFooterData } from "@/globals/stores/storeFooterData";
import {
  useDropdownUser,
  IDropdownItem,
  IDropdownMeItem,
} from "@/globals/stores/storeDropdownData";

import {
  useAccountDataUser,
  IUserData,
} from "@/modules/5.account/stores/accountDataStore";

class PiniaStorageDB extends ionicStorageClass {
  constructor(name: string, storeName: string) {
    super(name, storeName);
  }

  //------Token------------------------------
  async clearToken() {
    await this.setDatabaseItem("token", null);
  }
  async saveToken() {
    const token = userTokenStore();
    const st = JSON.stringify(token.$state) as Stringified<IToken>;
    await this.setDatabaseItem("token", st);
  }
  async loadToken() {
    const token = userTokenStore();
    const tk = (await this.getDatabaseItem("token")) as any;
    const obj = JSON.parse(tk) as IToken;
    token.$patch(obj);
  }

  //----Header-Footer-Data----------------------
  async saveHeaderData() {
    const headData = useHeaderData();
    const str = JSON.stringify(headData.$state) as Stringified<any>;
    await this.setDatabaseItem("header-data", str);
  }
  async saveFooterData() {
    const footData = useFooterData();
    const str = JSON.stringify(footData.$state) as Stringified<any>;
    await this.setDatabaseItem("footer-data", str);
  }

  async saveDropdownData() {
    const dropData = useDropdownUser();
    const str = JSON.stringify(dropData.$state) as Stringified<any>;
    await this.setDatabaseItem("dropdown-data", str);
  }

  async loadHeaderData() {
    const headData = useHeaderData();
    const hf = (await this.getDatabaseItem("header-data")) as any;
    const obj = JSON.parse(hf) as IHeaderData;
    headData.$state = obj;
  }
  async loadFooterData() {
    const footData = useFooterData();
    const hf = (await this.getDatabaseItem("footer-data")) as any;
    const obj = JSON.parse(hf) as IFooterData;
    footData.$state = obj;
  }
  async loadDropdownData() {
    const dropData = useDropdownUser();
    const hf = (await this.getDatabaseItem("footer-data")) as any;
    const obj = JSON.parse(hf);
    dropData.$state = obj;
  }

  //----User-Data-Account (profile)---------------
  async saveUserDataAccount() {
    const userData = useAccountDataUser();
    const json = JSON.stringify(userData.$state) as Stringified<IUserData>;
    const dt = await this.setDatabaseItem("user-data-profile", json);
    console.log("SET-DB-", dt);
  }
  async loadUserDataAccount() {
    const userData = useAccountDataUser();
    const usrData = await this.getDatabaseItem("user-data-profile");
    if (usrData) {
      const obj = JSON.parse(usrData) as IUserData;
      userData.$patch(obj);
      console.log("loadUserDataAccount", obj);
      return true;
    } else {
      console.log("UserDataAccountDB do not exists");
      return false;
    }
  }
  //----Offline-User (header dropdown)---------------
  async saveOfflineUser() {
    const dropData = useDropdownUser();
    const me = dropData.dropdownList.find((e) => e.kind === "me");
    if (!me) return;
    const avatar = await toDataUrl(me.avatar).catch(() => me.avatar);
    const str = JSON.stringify({ ...me, avatar }) as Stringified<any>;
    await this.setDatabaseItem("offline-user", str);
  }
  async loadOfflineUser() {
    const dropData = useDropdownUser();
    const account = useAccountDataUser();
    const str = await this.getDatabaseItem("offline-user");
    const saved = str ? (JSON.parse(str) as IDropdownItem) : undefined;
    const me: IDropdownItem =
      saved && saved.uuid === account.uuid
        ? saved
        : {
            kind: "me",
            name: account.name,
            shortname: account.shortname || account.name,
            uuid: account.uuid,
            avatar: account.avatar,
            stats: [],
          };
    dropData.dropdownList = [me as IDropdownMeItem];
    dropData.itemSelected = 0;
  }
  //----User-Preferences-(to personalize navigation)------------
}

async function toDataUrl(src: string): Promise<string> {
  const resp = await fetch(src);
  if (!resp.ok) throw new Error(`avatar fetch ${resp.status}`);
  const blob = await resp.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

const piniaStorageDB = new PiniaStorageDB(
  "pinia-storage-data",
  "pinia-storage-db",
);
export { piniaStorageDB };
